import { render, staticRenderFns } from "./BaseFormCard.vue?vue&type=template&id=75438908&"
import script from "./BaseFormCard.vue?vue&type=script&lang=js&"
export * from "./BaseFormCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports